import { PostsList } from "./PostsList";
import { Post } from "./Post";

export { PostsList, Post };
